import { cn } from '@helpers/styleUtils';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';

export const WidgetErrors = ({ error, title, size = 'large' }) => {
    return (
        <div
            className={cn(
                'bg-white p-4 rounded-[10px] space-y-4',
                size === 'large' ? 'col-span-2' : 'col-span-1',
            )}
        >
            <div className="text-lg font-bold">{title}</div>
            <p className="text-red-500 font-semibold space-y-2 text-sm">
                Error loading requests: <span className="text-gray-500 block">{parse(error)}</span>
            </p>
        </div>
    );
};

WidgetErrors.propTypes = {
    error: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    size: PropTypes.string,
};
